import { css } from "@emotion/css"

import Spacer from "@p-ban/common/src/components/layout/Spacer"

import ImportantDescriptionLink from "../../../components/ImportantDescriptionLink/ImportantDescriptionLink"
import AlignCenterHorizontally from "../../../components/mypage/layout/AlignCenterHorizontally"
import type { SeminarValues } from "../api/seminarApi"

type Props = {
  children?: React.ReactNode
  seminar: SeminarValues
}

const ConfirmPrivacyPolicy = ({ children, seminar }: Props) => {
  if (!seminar.personalInfoProvidedTo) {
    return (
      <div>
        <div className={styles.container}>
          <div className={styles.title}>個人情報の取り扱いについて</div>
          <Spacer size={18} />
          <AlignCenterHorizontally>
            <ImportantDescriptionLink
              href="/others/privacy_policy.html"
              theme="red"
              description="個人情報の取り扱いについて"
              highlightedDescription="読む"
            />
          </AlignCenterHorizontally>
          <Spacer size={20} />
          <AlignCenterHorizontally>{children}</AlignCenterHorizontally>
        </div>
        <Spacer size={40} />
      </div>
    )
  }

  return (
    <div>
      <div className={styles.container}>
        <div className={styles.title}>共催会社での個人情報の取り扱いについて</div>
        <Spacer size={18} />
        <AlignCenterHorizontally>
          <ImportantDescriptionLink
            href="/others/privacy_policy.html"
            theme="red"
            description="個人情報の取り扱いについて"
            highlightedDescription="読む"
          />
        </AlignCenterHorizontally>
        <Spacer size={16} />
        <div className={styles.subContainer}>
          <span className={styles.label}>（共有される項目）</span>
          <span className={styles.field}>上記項目の全て</span>
        </div>
        <div className={styles.subContainer}>
          <span className={styles.label}>（共催会社）</span>
          <span className={styles.field}>{seminar.personalInfoProvidedTo}</span>
        </div>
        <div className={styles.subContainer}>
          <span className={styles.label}>（利用目的）</span>
          <span className={styles.field}>{seminar.purposeOfPersonalInfoUse}</span>
        </div>
        <Spacer size={20} />
        <AlignCenterHorizontally>{children}</AlignCenterHorizontally>
      </div>
      <Spacer size={40} />
    </div>
  )
}

export default ConfirmPrivacyPolicy

const styles = {
  container: css`
    width: 100%;
    padding: 20px 20px 20px 20px;
    border: 1px solid;
    border-color: #cccccc;
  `,
  title: css`
    margin-top: 1px;
    font-size: 18px;
    line-height: 1;
    color: #4d4d4d;
  `,
  subContainer: css`
    display: flex;
  `,
  label: css`
    flex: 1;
    width: 130px;
    font-size: 13px;
    line-height: 22px;
    color: #4d4d4d;
  `,
  field: css`
    width: 568px;
    font-size: 13px;
    line-height: 22px;
    color: #4d4d4d;
  `,
}
